import type { Conversation } from "./types";

export function unreadMessageTotal(conversations: Conversation[] | undefined): number {
  return (conversations ?? []).reduce(
    (total, conversation) => total + Math.max(0, conversation.unread || 0),
    0,
  );
}

export function unreadBadgeLabel(total: number): string {
  return total > 99 ? "99+" : String(total);
}
